import Vue from 'vue'
import Router from 'vue-router'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Home from '@/pages/Home'

Vue.use(Router)
Vue.use(ElementUi)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/advertiser',
      name: 'advertiser',
      component: () => import('@/pages/advertiser')
    },
    {
      path: '/affiliate',
      name: 'affiliate',
      component: () => import('@/pages/affiliate')
    },
    {
      path: '/company',
      name: 'company',
      component: () => import('@/pages/company')
    },
    {
      path: '/campaign',
      name: 'campaign',
      component: () => import('@/pages/campaign')
    },
    {
      path: '/blog',
      name: 'blog',
      component: () => import('@/pages/blog')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js